import { render } from "./fiches.vue?vue&type=template&id=35eca284&scoped=true"
import script from "./fiches.vue?vue&type=script&lang=js"
export * from "./fiches.vue?vue&type=script&lang=js"

import "./fiches.vue?vue&type=style&index=0&id=35eca284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35eca284"]])

export default __exports__